// i18n
import 'src/locales/i18n';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

// routes
import Router from 'src/routes/sections';
// theme
import ThemeProvider from 'src/theme';
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsProvider, SettingsDrawer } from 'src/components/settings';
// auth
import { AuthProvider, AuthConsumer } from 'src/auth/context/azure';
import { ModuleEntitlementsConsumer, ModuleEntitlementsProvider } from 'src/entitlements';
import { PublicClientApplication } from '@azure/msal-browser';
import { SnackbarProvider } from './components/snackbar';
import { LocalizationProvider } from './locales';
// ----------------------------------------------------------------------

export default function App({ pca }: { pca: PublicClientApplication }) {

  useScrollToTop();

  return (
    <AuthProvider msalInstance={pca}>
      <ModuleEntitlementsProvider>
        <LocalizationProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light', // 'light' | 'dark'
            themeDirection: 'ltr', //  'rtl' | 'ltr'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <SnackbarProvider>
                <SettingsDrawer />
                <ProgressBar />
                <AuthConsumer>
                  <ModuleEntitlementsConsumer>
                    <Router />
                  </ModuleEntitlementsConsumer>
                </AuthConsumer>
              </SnackbarProvider>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
        </LocalizationProvider>
      </ModuleEntitlementsProvider>
    </AuthProvider>
  );

}
